class CookieAnalytics {
    init() {
        if (this.initialized) {
            return;
        }
        if (typeof window === 'undefined') {
            return;
        }
        this.initialized = true;
        this.waitForOneTrust(()=>{
            this.setupEventListeners();
            this.trackBannerShownIfNeeded();
        });
    }
    waitForOneTrust(callback) {
        if (window.OneTrust) {
            callback();
            return;
        }
        const handleOneTrustLoaded = ()=>{
            if (window.OneTrust) {
                window.removeEventListener('oneTrustLoaded', handleOneTrustLoaded);
                callback();
            }
        };
        window.addEventListener('oneTrustLoaded', handleOneTrustLoaded);
    }
    setupEventListeners() {
        if (!window.OneTrust?.OnConsentChanged) {
            return;
        }
        window.OneTrust.OnConsentChanged(()=>{
            this.trackConsentChanged();
            this.trackBannerClosedIfNeeded();
        });
    }
    trackBannerShownIfNeeded() {
        if (!window.OneTrust?.IsAlertBoxClosed) {
            return;
        }
        if (!window.OneTrust.IsAlertBoxClosed()) {
            this.trackBannerShown();
        }
    }
    trackBannerClosedIfNeeded() {
        if (!window.OneTrust?.IsAlertBoxClosed) {
            return;
        }
        if (window.OneTrust.IsAlertBoxClosed()) {
            this.trackBannerClosed();
        }
    }
    trackBannerShown() {
        if (!window.analytics?.track) {
            return;
        }
        window.analytics.track('website_cookie_banner_shown', {
            cookie_vendor: 'onetrust'
        });
    }
    trackConsentChanged() {
        if (!window.analytics?.track) {
            return;
        }
        window.analytics.track('website_cookie_consent_changed', {
            cookie_vendor: 'onetrust',
            active_categories: window.OnetrustActiveGroups.split(',').filter(Boolean).join(',')
        });
    }
    trackBannerClosed() {
        if (!window.analytics?.track) {
            return;
        }
        window.analytics.track('website_cookie_banner_closed', {
            cookie_vendor: 'onetrust'
        });
    }
    constructor(){
        this.initialized = false;
    }
}
function initializeCookieAnalytics() {
    if (typeof window === 'undefined') {
        return new CookieAnalytics();
    }
    if (!window.CookieAnalytics) {
        window.CookieAnalytics = new CookieAnalytics();
        window.CookieAnalytics.init();
    }
    return window.CookieAnalytics;
}

export { CookieAnalytics, initializeCookieAnalytics };
